import React from "react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";




export const Main = () => {
  return (
   <BrowserRouter>
   <App/>
   </BrowserRouter>
  );
};
